import { deleteBranchMutation } from 'app/branches/api';
import { createRoutine } from 'app/common/utils/new-routines';
import { getRoutineSaga } from 'app/common/utils/new-sagas';
import type { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import type { ActionType } from 'typesafe-actions';
import { showMessage } from '../../messages/actions';
import { setCurrentBranch } from '../actions';
import { DEFAULT_BRANCH } from '../constants';
import { getCurrentBranchName } from '../selectors';

export const deleteBranchRoutine = createRoutine('branches/DELETE_BRANCH')<
  { name: string },
  undefined,
  undefined,
  undefined,
  string,
  undefined
>();

export function* deleteBranchSaga(payload: undefined, { name }: { name: string }): SagaIterator {
  return yield call(deleteBranchMutation, name);
}

export function* deleteBranchFulfilledSaga({ meta }: ActionType<typeof deleteBranchRoutine.fulfilled>): SagaIterator {
  const { name } = meta;

  yield put(showMessage('info', 'Branch deleted', 3000));

  const currentBranchName = yield select(getCurrentBranchName);
  if (name === currentBranchName) {
    yield put(
      setCurrentBranch({
        branch: DEFAULT_BRANCH,
        snackbarMessage: false
      })
    );
  }
}

export function* deleteBranchRejectedSaga(): SagaIterator {
  yield put(showMessage('error', 'Failed to delete branch'));
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(deleteBranchRoutine.requested, getRoutineSaga(deleteBranchRoutine, deleteBranchSaga)),
    takeLatest(deleteBranchRoutine.fulfilled, deleteBranchFulfilledSaga),
    takeLatest(deleteBranchRoutine.rejected, deleteBranchRejectedSaga)
  ]);
}
